import React, { useState } from "react";
import { useToast } from "../../modules/layout/components/ToastContext";
import { remove } from "../_request";
import { getAccessToken } from "../../../setup/auth/authService";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


interface UnassignOtpAppSetupProps {
  targetProfileId: string;
}

export default function UnassignOtpAppSetup({targetProfileId}: UnassignOtpAppSetupProps) {
  
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [ open, setOpen ] = useState(false);

  const handleUnassignOtp = async () => {
    try {
    const token = await getAccessToken();
    if (!token) throw new Error("No token");

    const result: any = await remove('api/UserEvents/unassignotpapp', { params: { targetProfileId }, });

    const respStatus = result?.status ?? result?.response?.status;
    if (respStatus === 200 || respStatus === 204 || respStatus === undefined) {
                showToast && showToast(t('OtpUnassignedSuccessfully'), 'success');
            } else if (respStatus === 401) {
                navigate('/auth/login');
            } else if (respStatus === 403) {
                navigate('/error/403');
            } 
            else if (respStatus === 404) {
                showToast && showToast(t('ProfileNotFound'), 'error');
            } 
            else if (respStatus === 500) {
                navigate('/error/500');
            } else {
                showToast && showToast(t('StatusCode', { code: String(respStatus) }), 'error');
            }
        } catch (err: any){
            console.error(err);
            showToast && showToast(t('ConnectionError', { error: String(err) }), 'error');
        } finally {
        setLoading(false);
        setOpen(false);
    };
};

  return (
    <>
    <button className="btn gg-btn me-2" onClick={() => setOpen(true)}>
        {t('ResetOTPApp')}

      </button>

    {open && (
                <div className="gg-modal-overlay">
                    <div className="gg-modal">
                        <div className="gg-modal-header">
                            <h5 className=" mb-0">
                                {t('ConfirmOtpUnassignment')}
                            </h5>
                        </div>

                        <div className="gg-modal-body">
                            <p className="text-muted small mb-0">
                                 {t('OTPReset')}
                            </p>
                        </div>

                        <div className="gg-modal-footer">
                            <button
                                className="gg-btn"
                                onClick={() => setOpen(false)}
                                disabled={loading}
                            >
                                {t('Cancel')}
                            </button>

                            <button className="btn btn-secondary text-white"
                                    onClick={handleUnassignOtp}
                                    disabled={loading}
                                    >
                                    {loading ? t('UnassigningOTP...') : t('ResetOTPApp')}
                            </button>
                        </div>
                    </div>
                </div>
            )}     
    </>  
  );
};
